import InfoIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";
import "./TooltipInfoComponent.css";

const TooltipInfoComponent = ({ content, size }) => (
  <div className='tooltip-info'>
    <Tooltip arrow placement='top' title={content}>
      <InfoIcon fontSize={size} />
    </Tooltip>
  </div>
);

export default TooltipInfoComponent;
